/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 17:52:41
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-25 15:15:10
 */

import { Button, TableColumnType } from "antd";

export const AccountColumns = (
  startIndex: number,
  onclick: (userId: number, text: string, userName?: any,) => void
): TableColumnType<any>[] => {
  return [
    {
      title: "序号",
      align: "center",
      width: "100px",
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: "用户名",
      dataIndex: "userName",
      align: "center",
      width: "20%",
    },
    {
      title: "姓名",
      dataIndex: "nickName",
      align: "center",
      width: "20%",
    },
    {
      // 启用状态 0 未启用，1 启用
      title: "启用状态",
      dataIndex: "status",
      align: "center",
      width: "20%",
      render: (_, t) => {
        return t.status ? "启用" : "停用";
      },
    },
    {
      title: "操作",
      dataIndex: "",
      align: "center",
      width: "20%",
      render: (_, t) => {
        return (
          <div>
            <Button
              style={{ marginRight: "15px" }}
              type="primary"
              ghost
              size="small"
              onClick={() => {
                onclick(t.userId, "edit");
              }}
            >
              编辑
            </Button>
            {t.status ?
              <Button
                type="primary"
                size="small"
                onClick={() => {
                  onclick(t.userId, "change", t.userName,);
                }}
              >
                停用
              </Button>
              :
              <Button
                type="primary"
                danger
                size="small"
                onClick={() => {
                  onclick(t.userId, "change", t.userName,);
                }}
              >
                启用
              </Button>
            }

          </div>
        );
      },
    },
  ];
};
